export const config = {
  gameName: "The Lord of the Rings LCG",
};
